import * as React from "react";
import { FC, ButtonHTMLAttributes } from "react";
//@ts-ignore
import spinnerIcon from "../../images/spinner.svg";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  children: React.ReactNode;
}
export const Button: FC<ButtonProps> = (props) => (
  <button
    type="submit"
    className={`btn-cuppy btn-cuppy-2 transition ease-in-out flex justify-center items-center gap-2 ${props.className}`}
    {...props}
  >
    {props.children}
    {props.loading && <img src={spinnerIcon} />}
  </button>
);
